import React from 'react';
interface ReviewProps {
  name: string;
  rating: string;
  title: string;
  content: string;
}
const Review: React.FC<ReviewProps> = ({
  name,
  rating,
  title,
  content
}) => {
  return <div className="border border-gray-200 rounded-lg p-5 mb-4" data-id="element-42">
      <div className="flex justify-between items-start mb-2" data-id="element-43">
        <div data-id="element-44">
          <div className="font-semibold text-lg" data-id="element-45">{name}</div>
          <div className="text-sm text-teal-600 font-medium" data-id="element-46">
            Verified buyer
          </div>
        </div>
      </div>
      <div className="text-yellow-500 mb-2" data-id="element-47">{rating}</div>
      <h3 className="font-bold text-lg mb-2" data-id="element-48">{title}</h3>
      <p className="text-gray-700" data-id="element-49">{content}</p>
    </div>;
};
export const CustomerReviews = () => {
  return <section className="w-full bg-gray-50 pt-8 pb-16" data-id="element-50">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-51">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-52">
          <Review name="Amanda B" rating="⭐️⭐️⭐️⭐️⭐️" title="Truly Feels Like Mine" content="I was so tired of apps that just dumped data on me. Zenora is different. The Sleep and Stress scores are so clear and easy to understand. I know exactly what to do to improve my habits and actually feel better. It's a relief not to feel overwhelmed by numbers anymore!" data-id="element-53" />
          <Review name="James L" rating="⭐️⭐️⭐️⭐️⭐️" title="Reliable Data Without Hidden Costs" content="Switched from a subscription tracker that drove me crazy with extra charges. This just works. HRV and sleep scores feel consistent and accurate. Love not worrying about daily charging. Wearing it 24/7 has been easy—even forgot it was on most nights." data-id="element-54" />
          <Review name="Sophie M" rating="⭐️⭐️⭐️⭐️⭐️" title="Helps Make Sense of My Health" content="Tried other trackers that dumped too much data without guidance. Zenora's app actually helps me see patterns without feeling overwhelmed. Stress tracking was eye-opening, and adjusting my bedtime based on insights has made mornings feel so much better. No fees is just icing on top." data-id="element-55" />
          <Review name="David K" rating="⭐️⭐️⭐️⭐️⭐️" title="Better Than Any Watch I Tried" content="Hated wearing a chunky watch to sleep. This ring is subtle and comfortable all day. Data feels spot-on, especially for sleep stages and recovery. Big fan of knowing there's no subscription waiting to surprise me later. Just buy it once and actually own it." data-id="element-56" />
          <Review name="Emily R" rating="⭐️⭐️⭐️⭐️⭐️" title="Finally Feels Like an Investment" content="After wasting money on overpriced, inaccurate trackers with subscriptions, Zenora has been a relief. No fees, reliable battery, and insights that actually make me rethink habits. Feels like a tool to stay healthy long-term instead of another tech gimmick. Highly recommend it for anyone serious about real change." data-id="element-57" />
        </div>
      </div>
    </section>;
};